/**
 * Clamp QC job SKUs (90-002-QC / 90-003-QC, and TLA variants) map to the finished
 * inventory label SKUs used on 4x2 carton labels.
 */

export const CLAMP_QC_SMALL_INVENTORY_LABEL_SKU = "90-002-TLA";
export const CLAMP_QC_LARGE_INVENTORY_LABEL_SKU = "90-003-TLA";

export function inventoryLabelSkuFromClampQcJobSku(jobSku: string): string | null {
  const upper = jobSku.trim().toUpperCase();
  if (upper.startsWith("90-002")) {
    return CLAMP_QC_SMALL_INVENTORY_LABEL_SKU;
  }
  if (upper.startsWith("90-003")) {
    return CLAMP_QC_LARGE_INVENTORY_LABEL_SKU;
  }
  return null;
}

/** Puts the work order on the 4x2 variant line (that template has no dedicated WO field). */
export function inventoryVariantWithWorkOrder(existingVariant: string, workOrder: string): string {
  const note = workOrder.trim() === "" ? "" : `Work order ${workOrder.trim()}`;
  const variant = existingVariant.trim();
  if (note === "") {
    return variant;
  }
  if (variant === "") {
    return note;
  }
  if (variant.includes(note)) {
    return variant;
  }
  return `${variant} · ${note}`;
}
